<!--
무자료 수동등록 > 상품
------------------------------------
-->
<template>
    <tr
        :class="className"
    >
        <td class="uk-text-center">
            <a :href="'/prods/' + prod.id" target="_blank" class="uk-link-reset">{{ prod.id }}</a>
        </td>
        <td class="uk-text-left">

            <div title="회원사서함"><i class="material-icons uk-text-muted">mail</i> {{ prod.user_mailbox }} </div>
            <div title="수취인이름" v-if="prod.tracking_recipient_name"><i class="material-icons uk-text-muted">person</i> {{ prod.tracking_recipient_name }} </div>

        </td>

        <td class="uk-text-left">
            <div title="트래킹번호" class="uk-text-bold"><i class="material-icons uk-text-muted">local_shipping</i> {{ prod.tracking_no }} </div>
            <div title="상품명" class="uk-margin-small-top"><i class="material-icons uk-text-muted">info</i> {{ prod.name }}</div>

        </td>
        <td class="uk-text-center">
            {{ prod.amount }}
        </td>
        <td class="uk-text-center">
            {{ prod.size }}
        </td>

        <td class="uk-text-left">
            <div title="색상" v-if="prod.color"><i class="material-icons uk-text-muted">info</i> {{ prod.color }} </div>
            <div title="유통기한" v-if="prod.expiration_date"><i class="material-icons uk-text-muted">info</i> {{ prod.expiration_date }} </div>
        </td>
        <td class="uk-text-center">
            {{ prod.storage }}
        </td>

        <td class="uk-text-center">
            <button
                class="uk-button uk-button-small uk-button-dark"
                v-show="mode === 'add'"
                @click="$emit('click:update', prod)"
            >
                수정
            </button>

            <button
                class="uk-button uk-button-small uk-button-white"
                v-show="mode === 'update' && selected"
                @click="$emit('click:cancel-update', prod)"
            >
                취소
            </button>

        </td>
        <td class="uk-text-center">
            <button
                class="uk-button uk-button-small uk-button-danger"
                v-show="mode === 'add'"
                @click="$emit('click:remove', prod)"
            >
                삭제
            </button>

            <button
                class="uk-button uk-button-small uk-button-white"
                v-show="mode === 'remove' && selected"
                @click="$emit('click:cancel-remove', prod)"
            >
                취소
            </button>
        </td>


    </tr>
</template>

<script>

    export default {
        components: {

        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

            // (array) 지역 회원사 옵션
            regionMemberOptions: {
                type: Array,
                default: [],
            },

            // (int) 업로드모듈에서 사용할 로그인ID
            sessionOwner: {
                type: Number,
                default: null,
            },

            /**
             * 상품정보
             */
            prod: {
                type: Object,
            },

            /**
             * 선택된 상품번호(수정, 삭제 등..)
             */
            selectedProdId: {
                type: Number,
                default: null,
            },

            /**
             * 편집모드
             */
            mode: {
                type: String,
                required: true,
            },

        },
        data: function () {
            return {

            };
        },
        mounted: function () {

        },
        computed: {
            // 현재 상품이 편집모드로 선택된 상품인지 여부
            selected() {
                return this.selectedProdId === this.prod.id;
            },
            className() {
                return {
                    selected: this.selectedProdId && this.selected,
                    unselected: this.selectedProdId && this.selected === false,
                }
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
td {
    padding: 0.25rem;
    border: 1px solid #cfcfcf;
    background-color: #fff;
    font-size: 1.25rem;
    color: #000;
}

tr:hover td {
    background-color: #d8eafc;
}

.hover td {
    background-color: #fff;
}

.selected td, tr:hover.selected td {
    background-color: #fff;
}
.unselected td, tr:hover.unselected td  {
    background-color: #666;
    border: 1px solid #333;
}

</style>